<mat-form-field *ngIf='control' appearance='outline'>

  <mat-label>Atleta</mat-label>

  <input matInput [formControl]='control'>

</mat-form-field>
